import { FormattedMessage } from "react-intl";
import ChevronIcon from "svg-icons/chevron-icon.js";
import PersonalDataSection from "./PersonalDataSection";
import EmployerDataSection from "./EmployerDataSection";
import EducationSection from "./EducationSection";
import TrainerDataSection from "./TrainerDataSection";

export default function NationalCenterForm({
  register,
  errors,
  dir,
  currentLocale,
  trainingPrograms,
  governorates,
  onSubmit,
}) {
  return (
    <form onSubmit={onSubmit}>
      <PersonalDataSection
        register={register}
        errors={errors}
        dir={dir}
        currentLocale={currentLocale}
        trainingPrograms={trainingPrograms}
        governorates={governorates}
      />
      <EmployerDataSection
        register={register}
        errors={errors}
        dir={dir}
        currentLocale={currentLocale}
      />
      <EducationSection
        register={register}
        errors={errors}
        dir={dir}
        currentLocale={currentLocale}
      />
      <TrainerDataSection register={register} errors={errors} />

      <div className="row-r mt-4">
        <button className="main-btn" type="submit">
          <span>
            <FormattedMessage id="send" />
          </span>
          <ChevronIcon width={12} height={12} color="#FFFFFF" />
        </button>
      </div>
    </form>
  );
}
